export const partnersTr = {
  discardTitle: 'Kaydedilmemiş değişiklikler silinsin mi?',
  discardDescription:
    'Değişiklikleriniz kaydedilmedi. Düzenlemeye devam edin veya açıkça silmeyi seçin.',
  keepEditing: 'Düzenlemeye devam et',
  discard: 'Sil',

  all: {
    title: 'Tüm kişiler',
    subtitle: 'Tüm iş ortaklarına ve rollerine ilişkin eksiksiz genel bakış.',
  },
  customers: {
    title: 'Müşteriler',
    subtitle: 'Tüm aktif müşterilerin alacak hesapları, vadeleri ve gelirleri.',
  },
  prospects: {
    title: 'Aday müşteriler / potansiyel müşteriler',
    subtitle: 'İlk temastan kapanışa kadar satış hattı.',
  },
  suppliers: {
    title: 'Tedarikçiler',
    subtitle: 'Borç hesapları, derecelendirmeler ve satın alma koşulları.',
  },
  searchPlaceholder: 'Adı, numarayı, şehri, KDV numarasını, hesabı arayın…',
  searchLabel: 'İş ortaklarını arayın',
  columnsMenu: 'Sütunlar',
  createTitle: 'Yeni iş ortağı',
  editTitle: 'Muhatabı düzenle',
  formDescription:
    'Roller hangi alanların görüneceğini kontrol eder. Ortak numarası boş bırakılırsa otomatik olarak atanır.',
  created: 'İş ortağı oluşturuldu.',
  updated: 'İş ortağı kaydedildi.',
  saveError: 'İş ortağı kaydedilemedi.',
  validationTitle: 'Bilgileri kontrol edin',
  validationSummary: 'Lütfen işaretli bilgileri kontrol edin. Girdileriniz korunmuştur.',
  quick: {
    title: 'Hızlı oluştur',
    description: 'Kayıt için rol ve ad yeterlidir. Diğer bilgiler daha sonra eklenebilir.',
    completeTitle: 'Eksiksiz oluşturma',
    completeDescription: 'Tüm ana verileri ve koşulları düzenleyin.',
    showAll: 'Tüm alanları göster',
    showQuick: 'Hızlı oluşturmaya dön',
    defaultsUnavailable:
      'Kiracı varsayılanları geçici olarak yüklenemedi. Güvenli varsayılan değerler gösteriliyor.',
    step1: '1. Müşteri veya şirket',
    step2: '2. Adres (isteğe bağlı)',
    step3: '3. İletişim (isteğe bağlı)',
    step4: '4. Faturalama ve vergi (isteğe bağlı)',
    completionHint:
      'Kaydettikten sonra dosyayı tamamlayabilirsiniz. Belge kesinleştirilmeden önce eksik iş bilgilerini kontrol listesinde gösterir.',
  },
  roles: {
    customer: 'Müşteri',
    prospect: 'Aday müşteri',
    supplier: 'Tedarikçi',
  },
  actions: {
    create: 'Yeni ortak',
    createCustomer: 'Yeni müşteri',
    createProspect: 'Yeni potansiyel müşteri',
    createSupplier: 'Yeni tedarikçi',
    export: 'Dışa Aktar',
    call: 'Ara',
    email: 'E-posta',
    logCall: 'Aramayı günlüğe kaydet',
    createQuote: 'Belge oluştur',
    convert: 'Müşteriye dönüştür',
    backToList: 'Genel bakışa dön',
  },
  tabs: {
    master: 'Ana veriler ve adresler',
    sales: 'Gelir ve belgeler',
    purchasing: 'Satın alma ve ürünler',
    orders: 'Satın alma siparişleri',
    insurance: 'Kredi limiti ve sigorta',
    customFields: 'Özel alanlar',
    history: 'Geçmiş',
    telephony: 'Telefon ve geçmiş',
    whatsapp: 'WhatsApp',
  },
  sections: {
    roles: 'Roller',
    rolesHint:
      'Bir ortak aynı anda müşteri, potansiyel müşteri ve tedarikçi olabilir. En az bir rol gerekli.',
    masterData: 'Ana veriler',
    address: 'Adres',
    tax: 'Vergi ve kimlik',
    customerConditions: 'Müşteri şartları',
    prospect: 'Potansiyel müşteri ve satış hattı',
    supplier: 'Tedarikçi verileri',
    customFields: 'Özel alanlar',
    customFieldsHint:
      'Grup ön ekine sahip alanlar (müşteri:, potansiyel müşteri:, tedarikçi:) yalnızca eşleşen rol için görünür.',
  },
  detail: {
    since: '{{date}} tarihinde oluşturuldu',
  },
  values: {
    days_one: '{{count}} gün',
    days_other: '{{count}} gün',
  },
  columns: {
    partnerNumber: 'Sayı',
    displayName: 'Ad',
    roles: 'Roller',
    status: 'Durum',
    industry: 'Endüstri',
    industryCode: 'Sektör kodu',
    email: 'E-posta',
    phone: 'Telefon',
    city: 'Şehir',
    countryCode: 'Ülke',
    tags: 'Etiketler',
    debtorAccountNumber: 'Borçlu',
    paymentTermsDays: 'Ödeme koşulları',
    creditLimit: 'Kredi limiti',
    leadStatus: 'Aşama',
    leadSource: 'Kaynak',
    leadScore: 'Puan',
    dealSizeEstimated: 'Potansiyel',
    winProbability: 'Olasılık',
    expectedClosingDate: 'Beklenen kapanış',
    creditorAccountNumber: 'Alacaklı',
    supplierRating: 'Derecelendirme',
    minimumOrderValue: 'Minimum sipariş değeri',
    deliveryTimeDays: 'Teslim süresi',
    riskStatus: 'Risk',
  },
  fields: {
    type: 'İş ortağı türü',
    status: 'Durum',
    partnerNumber: 'İş ortağı numarası',
    partnerNumberHint: 'Otomatik atama için boş bırakın (KD-, INT-, LF-).',
    industry: 'Endüstri',
    industryCode: 'Sektör kodu',
    industryCodeHint:
      'İsteğe bağlı: Almanya için WZ 2025, Fransa için NAF/APE. Kod veya resmî adla arayın; seçim sektörü otomatik doldurur.',
    industryCodeSearchHint:
      '{{count}} kod mevcut. Seçimi daraltmak için bir kod veya arama terimi girin.',
    industryCodeInvalid: 'En fazla {{max}} karakter içeren bir metin girin.',
    companyName: 'Şirket adı',
    tradingName: 'Ticaret adı',
    legalForm: 'Yasal form',
    department: 'Departman',
    firstName: 'Ad',
    lastName: 'Soyadı',
    email: 'E-posta',
    phone: 'Telefon',
    mobile: 'Mobil',
    website: 'Web sitesi',
    street: 'Sokak',
    houseNumber: 'Ev numarası',
    addressLine2: 'Adres satırı 2',
    postalCode: 'Posta kodu',
    city: 'Şehir',
    region: 'Bölge',
    countryCode: 'Ülke',
    vatId: 'KDV Numarası',
    vatIdStatus: 'KDV Numarası durumu',
    taxNumber: 'Vergi numarası',
    siren: 'SIREN',
    siret: 'SIRET',
    taxCategory: 'Satış vergisi stratejisi',
    gln: 'GLN',
    eoriNumber: 'EORI numarası',
    preferredLanguage: 'Tercih edilen belge dili',
    preferredLanguageHint:
      'Yeni belgeler, portal içerikleri ve müşteriye gönderilen e-postalar için kullanılır.',
    currency: 'Para birimi',
    ownerName: 'Hesap yöneticisi',
    tags: 'Etiketler',
    tagsHint: 'Birden fazla değeri virgülle ayırın.',
    debtorAccountNumber: 'DATEV borçlu hesabı',
    debtorAccountHint: 'Geçerli aralık: 10000–69999.',
    creditLimit: 'Kredi limiti',
    creditRating: 'Kredi notu',
    creditRatingHint: 'Kredireform ölçeği 100–600; daha düşük olması daha iyidir.',
    priceGroup: 'Fiyat grubu',
    defaultDiscountPct: 'İndirim',
    paymentTerms: 'Ödeme koşulları',
    paymentTermsDays: 'Ödeme koşulları (gün)',
    discountPercent: 'Nakit indirimi',
    discountDays: 'Nakit iskonto süresi (gün)',
    deliveryTerms: 'Teslimat şartları',
    minRemainingShelfLifeDays: 'Minimum kalan raf ömrü (gün)',
    deliveryBlock: 'Teslimat bloğu',
    dunningBlock: 'İhtar bloğu',
    leadStatus: 'Ardışık düzen aşaması',
    leadSource: 'Kaynak',
    leadScore: 'Liderlik puanı (0-100)',
    dealSizeEstimated: 'Tahmini anlaşma boyutu',
    winProbability: 'Kazanma olasılığı (%)',
    expectedClosingDate: 'Beklenen kapanış tarihi',
    lostReason: 'Kayıp nedeni',
    convertedAt: 'Dönüştürülme tarihi',
    creditorAccountNumber: 'DATEV alacaklı hesabı',
    creditorAccountHint: 'Geçerli aralık: 70000–99999.',
    supplierRating: 'Tedarikçi derecelendirmesi',
    minimumOrderValue: 'Minimum sipariş değeri',
    deliveryTimeDays: 'Standart teslim süresi (gün)',
    incoterms: 'Incoterms',
    supplierIban: 'IBAN',
    supplierBic: 'BIC',
    supplierBankName: 'Banka',
  },
  types: {
    COMPANY: 'Şirket',
    PERSON: 'Bireysel',
  },
  statuses: {
    ACTIVE: 'Aktif',
    PROSPECT: 'Aday müşteri',
    BLOCKED: 'Engellendi',
    INACTIVE: 'Aktif Değil',
  },
  vatIdStatuses: {
    UNCHECKED: 'İşaretlenmemiş',
    VALID: 'Geçerli',
    INVALID: 'Geçersiz',
    NOT_CHECKABLE: 'Kontrol edilemiyor',
    SERVICE_UNAVAILABLE: 'Hizmete ulaşılamıyor',
  },
  taxCategories: {
    DOMESTIC: 'Normal (yurtiçi)',
    EU_B2B: 'Topluluk içi (AB B2B)',
    EU_B2C: 'AB B2C',
    THIRD_COUNTRY: 'İhracat (üçüncü ülke)',
    REVERSE_CHARGE_DOMESTIC: 'Ters şarj (yurtiçi)',
    TAX_EXEMPT: 'Vergiden muaf',
  },
  industries: {
    RETAIL: 'Perakende',
    WHOLESALE: 'Toptan Satış',
    MANUFACTURING: 'İmalat',
    GASTRONOMY: 'Gastronomi',
    LOGISTICS: 'Lojistik',
    HEALTHCARE: 'Sağlık Hizmeti',
    PUBLIC_SECTOR: 'Kamu sektörü',
    CONSTRUCTION: 'İnşaat',
    AGRICULTURE: 'Tarım',
    SERVICES: 'Hizmetler',
    OTHER: 'Diğer',
  },
  leadStatuses: {
    NEW: 'Yeni',
    CONTACTED: 'ile iletişime geçildi',
    QUALIFIED: 'Nitelikli',
    PROPOSAL_SENT: 'Teklif gönderildi',
    NEGOTIATION: 'Pazarlık',
    WON: 'Kazandı',
    LOST: 'Kayıp',
  },
  leadSources: {
    WEBSITE: 'Web sitesi',
    TRADE_FAIR: 'Ticaret fuarı',
    REFERRAL: 'Yönlendirme',
    COLD_OUTREACH: 'Soğuk erişim',
    INBOUND_CALL: 'Gelen çağrı',
    OTHER: 'Diğer',
  },
  supplierRatings: {
    A: 'A – çok güvenilir',
    B: 'B – kabul edilebilir',
    C: 'C – kritik',
  },
  riskStatuses: {
    NORMAL: 'Olağanüstü',
    WATCHLIST: 'İzleme listesi',
    DELIVERY_LOCK: 'Teslimat kilidi',
    SALES_LOCK: 'Satış kilidi',
    COLLECTION: 'Borç tahsilatı / kilitli',
    INSOLVENCY: 'İflas',
  },
  risk: {
    lockAction: 'Müşteriyi kilitle',
    unlockAction: 'Müşterinin kilidini aç',
    lockTitle: 'Kilit iş ortağı',
    lockDescription:
      'Kilit, {{name}} için her belgeyi anında engeller. Nedeni denetim günlüğüne kaydedilir.',
    lockConfirm: 'Kilidi uygula',
    lockSuccess: 'İş ortağı kilitli.',
    lockError: 'Kilit uygulanamadı.',
    unlockTitle: 'Kilidi serbest bırak',
    unlockDescription: '{{name}} üzerindeki kilit açılacaktır. Önceki neden: {{reason}}',
    unlockConfirm: 'Kilidi serbest bırak',
    unlockSuccess: 'Kilit açıldı.',
    unlockError: 'Kilit açılamadı.',
    reasonRequired: 'Bir neden gerekli.',
    fields: {
      riskStatus: 'Risk sınıflandırması',
      followUpStatus: 'Yayınlandıktan sonra sınıflandırma',
      blockReason: 'Kilitlenme nedeni',
      blockReasonHint:
        'Örnek: “İflas mahkemesi dosya numarası: IN 412/26” veya “15/08/2026 tarihinde Creditreform tahsilatına teslim edildi”.',
      unblockReason: 'Yayınlanma nedeni',
      unblockReasonHint: 'Örnek: “Alacak 01/09/2026 tarihinde tamamen kapatılmıştır”.',
    },
    banner: {
      blockedTitle: '🚨 UYARI: MÜŞTERİ KİLİTLİ (durum: {{status}})',
      warningTitle: 'Risk sınıflandırması: {{status}}',
      reason: 'Sebep: {{reason}}',
      since: "{{user}} tarafından {{date}}'ye kilitlendi",
      consequence:
        'Hesapta hiçbir teslimat veya fatura oluşturulamaz; yalnızca ön ödeme veya nakit karşılığında serbest bırakılır.',
    },
  },
  insurance: {
    policySection: 'Sigorta poliçesi',
    claimSection: 'İddia',
    saved: 'Ticari alacak sigortası kaydedildi.',
    saveError: 'Ticari alacak sigortası kaydedilemedi.',
    limitExceededHint:
      'Sigortalı maksimum limit doldu. Daha sonraki teslimatlar kapsam dışındadır.',
    claimIdleHint: 'Talep bölümü, müşteri tahsilata veya iflasa geçtiğinde alakalı hale gelir.',
    openAmount: 'Açık alacaklar: {{amount}}',
    expectedPayout: 'Beklenen sigorta tazminatı',
    expectedPayoutHint: "Talep tutarından {{percent}}'nin düşülebilir tutarı düşüldükten sonra.",
    actions: {
      prepareClaim: 'Kayıt talebi',
    },
    statuses: {
      NOT_INSURED: 'Sigortalı değil',
      INSURED: 'Sigortalı',
      LIMIT_EXCEEDED: 'Sınır aşıldı',
      CLAIM_REPORTED: 'İddia bildirildi',
      INDEMNIFIED: 'Tazmin edildi',
    },
    fields: {
      status: 'Sigorta durumu',
      company: 'Sigorta şirketi',
      companyHint: 'Örnek: Allianz Trade / Euler Hermes, Atradius, Coface.',
      policyNumber: 'Poliçe / limit numarası',
      limit: 'Sigortalı maksimum limit (€)',
      deductiblePercent: 'Muafiyet (%)',
      deductibleHint: 'Hak talebinde bulunulması durumunda kiracının taşıdığı pay.',
      claimDate: 'Talep raporu tarihi',
      claimAmount: 'Bildirilen talep tutarı (€)',
      payoutAmount: 'Tazmin edilen tutar (€)',
    },
  },
  incoterms: {
    EXW: 'Eski işler',
    FCA: 'Ücretsiz operatör',
    FAS: 'Geminin yanında serbest',
    FOB: 'Gemide bedava',
    CFR: 'Maliyet ve navlun',
    CIF: 'Maliyet, sigorta ve navlun',
    CPT: 'Taşıma ücreti ödendi',
    CIP: 'Nakliye ve sigorta ödendi',
    DAP: 'Yerinde teslim edildi',
    DPU: 'Boşaltılmış bir yerde teslim edildi',
    DDP: 'Görevi ödenmiş olarak teslim edildi',
  },
  documentTypes: {
    QUOTE: 'Alıntı',
    ORDER: 'Sipariş',
    DELIVERY_NOTE: 'Teslimat notu',
    INVOICE: 'Fatura',
    CREDIT_NOTE: 'Kredi notu',
    CANCELLATION: 'İptal',
    PURCHASE_ORDER: 'Satınalma siparişi',
  },
  documentStatuses: {
    DRAFT: 'Taslak',
    SENT: 'Gönderildi',
    ACCEPTED: 'Kabul edildi',
    REJECTED: 'Reddedildi',
    CONFIRMED: 'Onaylandı',
    IN_PROGRESS: 'Devam ediyor',
    PARTIALLY_PROCESSED: 'Kısmen işlendi',
    SHIPPED: 'Gönderildi',
    COMPLETED: 'Tamamlandı',
    POSTED: 'Gönderildi',
    CANCELLED: 'İptal edildi',
  },
  filters: {
    status: 'Durum',
    industry: 'Endüstri',
    industryCode: 'Sektör kodunu filtrele (tam)',
    tags: 'Etiketler',
    vatIdStatus: 'KDV Numarası',
    riskStatus: 'Risk',
    leadStatus: 'Ardışık düzen aşaması',
    leadSource: 'Kaynak',
    supplierRating: 'Derecelendirme',
    reset: 'Filtreleri sıfırla',
  },
  states: {
    empty: 'Henüz iş ortağı yok.',
    emptyFiltered: 'Mevcut seçimle eşleşen muhatap yok.',
    error: 'Liste yüklenemedi.',
    detailError: 'İş ortağı yüklenemedi.',
  },
  export: {
    csv: "CSV'yi indir",
    xlsx: "Excel'i İndir",
    success: 'Dışa aktarma oluşturuldu.',
    error: 'Dışa aktarma başarısız oldu.',
  },
  bulkDelete: {
    selected: 'Seçilen: {{count}}',
    action: 'Seçilenleri sil',
    help: 'Toplu aday müşteri silme yardımı',
    deleted: 'Silinen: {{count}}.',
    failed: 'Silinmeyen: {{count}}. Bu kayıtlar seçili kalır.',
    hasDocuments: 'Bu iş ortağının belgeleri var ve silinemez.',
    error: 'Kayıt silinemedi.',
    title: 'Seçilen aday müşterileri sil',
    description:
      'Seçilen aday müşteriler pasif hale getirilir ve gizlenir. Belgesi olan iş ortakları korunur. Silme, diğer rolleri de dahil iş ortağı kaydının tamamını etkiler.',
    select: '{{name}} kaydını seç',
    selectPage: 'Bu sayfadaki tümünü seç',
  },
  delete: {
    title: 'Muhatabı sil',
    description: '"{{name}}" ortağı devre dışı ve gizli olarak ayarlanacak.',
    success: 'İş ortağı silindi.',
    error: 'İş ortağı silinemedi.',
  },
  pipeline: {
    title: 'Satış hattı',
    viewSwitch: 'Görünümü değiştir',
    listView: 'Liste',
    boardView: 'Yönetim Kurulu',
    emptyColumn: 'Giriş yok',
    moved: '{{name}}, "{{stage}}" konumuna taşındı.',
    moveError: 'Ardışık düzen aşaması değiştirilemedi.',
    movePrevious: "{{name}}'yi bir adım geriye taşı",
    moveNext: "{{name}}'yi bir aşama ileri taşı",
    lostTitle: 'Potansiyel müşteriyi kayıp olarak işaretle',
    lostDescription: 'Lütfen kaybın nedenini belirtin.',
    lostPlaceholder: 'ör. Fiyat çok yüksek, rakip seçildi, proje ertelendi',
  },
  convert: {
    title: 'Potansiyel müşteriyi müşteriye dönüştürün',
    description: '"{{name}}" kaydı tutuluyor; çağrılar, notlar, alıntılar ve sohbetler aktarılır.',
    debtorHint: 'Bir sonraki ücretsiz DATEV borçlu numarasını atamak için boş bırakın.',
    debtorPlaceholder: 'otomatik',
    keepProspectRole: '"Potansiyel" rolünü de koruyun',
    success: 'Dönüşüm tamamlandı. Borçlu hesabı {{number}}.',
    error: 'Dönüştürme başarısız oldu.',
  },
  sales: {
    title: 'Gelir ve ödeme davranışı',
    loadError: 'Metrikler yüklenemedi.',
    revenueYtd: 'Yılbaşından bugüne gelir',
    revenuePreviousYear: 'Önceki yıl geliri',
    revenueChange: 'Önceki yıla göre değişim',
    orderIntake: 'Sipariş girişi',
    documentCounts: 'Teklif / sipariş / irsaliye / fatura',
    averageOrderValue: 'Ortalama sipariş değeri',
    paidAmount: 'Ödenen tutar',
    credits: 'Alacaklar ve iptaller',
    lastDocuments: 'Son sipariş / son fatura',
    period: 'Dönem',
    periods: {
      currentYear: 'Cari yıl',
      previousYear: 'Önceki yıl',
      last12Months: 'Son 12 ay',
      all: 'Tüm dönem',
      custom: 'Özel dönem',
    },
    from: 'Başlangıç',
    to: 'Bitiş',
    searchDocuments: 'Belge numarası veya referans ara …',
    allTypes: 'Tüm belge türleri',
    allStatuses: 'Tüm durumlar',
    allPayments: 'Tüm ödeme durumları',
    noDocumentPermission: 'Ciro ve belgeler için belge izni gereklidir.',
    columns: {
      number: 'Belge no.',
      type: 'Tür',
      date: 'Tarih',
      status: 'Durum',
      payment: 'Ödeme',
      net: 'Net',
      gross: 'Brüt',
      open: 'Açık',
      due: 'Vade',
      salesRep: 'Satış',
    },
    revenueTotal: 'Toplam gelir',
    openInvoices_one: 'Faturayı aç ({{count}})',
    openInvoices_other: 'Faturaları aç ({{count}})',
    overdueInvoices_one: 'Vadesi geçmiş fatura ({{count}})',
    overdueInvoices_other: 'Vadesi geçmiş faturalar ({{count}})',
    openQuotes: 'Açık tırnaklar',
    openOrders: 'Açık emirler',
    averagePaymentTermsDays: 'Ort. ödeme koşulları',
    lastOrderDate: 'Son sipariş',
    documents: 'Belgeler',
    documentsEmpty: 'Henüz belge yok.',
    documentsError: 'Belgeler yüklenemedi.',
  },
  supplierProducts: {
    title: 'Satın alma koşulları',
    subtitle: "Ürünler, tedarikçi SKU'ları, satın alma fiyatları ve teslim süreleri.",
    add: 'Bağlantı öğesi',
    createTitle: 'Satın alma koşulu ekle',
    editTitle: 'Satın alma koşulunu düzenle',
    description: 'Koşullar bu tedarikçi ve seçilen ürün için geçerlidir.',
    product: 'Öğe',
    productHint: 'Ürün numarasına veya adına göre arayın.',
    productPlaceholder: 'Ürün ara…',
    noProducts: 'Hiçbir öğe bulunamadı.',
    supplierSku: "Tedarikçi SKU'su",
    purchasePrice: 'Satın alma fiyatı (net)',
    packagingUnit: 'Paketleme ünitesi',
    packagingFactor: 'Paketleme birimi başına temel birim',
    leadTimeDays: 'Teslim süresi (gün)',
    minOrderQuantity: 'Minimum sipariş miktarı',
    isPreferredSupplier: 'Bu ürün için tercih edilen tedarikçi',
    preferred: 'Tercih Edilen',
    notes: 'Not',
    empty: 'Henüz satın alma koşulu yok.',
    saved: 'Satın alma koşulu kaydedildi.',
    saveError: 'Satın alma koşulu kaydedilemedi.',
    loadError: 'Satın alma koşulları yüklenemedi.',
    edit: 'Satın alma koşulunu düzenle',
    delete: 'Satın alma koşulunu sil',
    deleted: 'Satın alma koşulu silindi.',
    deleteTitle: 'Satın alma koşulunu sil',
    deleteDescription: '"{{name}}" koşulları kaldırılacak.',
    columns: {
      article: 'Öğe',
      supplierSku: "Tedarikçi SKU'su",
      purchasePrice: 'Satın alma fiyatı',
      packaging: 'Paketleme',
      leadTimeDays: 'Teslim süresi',
      minOrderQuantity: 'Min. miktar',
      preferred: 'Tercih Edilen',
    },
  },
  supplierOrders: {
    purchaseOrder: 'Satınalma siparişi',
    itemCount_one: '{{count}} satırı',
    itemCount_other: '{{count}} satırları',
    deliveryDate: 'Mal kabul: {{date}}',
    empty: 'Bu tedarikçi için henüz satın alma siparişi yok.',
    loadError: 'Satınalma siparişleri yüklenemedi.',
  },
  addresses: {
    title: 'Alternatif adresler',
    add: 'Adres',
    isDefault: 'Varsayılan',
    empty: 'Kayıtlı alternatif adres yok.',
    deleted: 'Adres silindi.',
    delete: 'Adresi sil',
    deleteTitle: 'Adresi sil',
    deleteDescription: 'Adres, ortak kaydından kaldırılacak.',
    loadError: 'Adresler yüklenemedi.',
    types: {
      BILLING: 'Fatura adresi',
      SHIPPING: 'Teslimat adresi',
      OTHER: 'Diğer',
    },
  },
  contacts: {
    title: 'Kişiler',
    add: 'İletişim',
    isPrimary: 'Birincil kişi',
    empty: 'Kayıtlı kişi yok.',
    deleted: 'Kişi silindi.',
    delete: 'Kişiyi sil',
    deleteTitle: 'Kişiyi sil',
    deleteDescription: 'Kişi ortak kaydından kaldırılacak.',
    loadError: 'Kişiler yüklenemedi.',
  },
  customFields: {
    title: 'Dinamik özel alanlar',
    subtitle: 'Yalnızca bu ortağın rolleriyle eşleşen alanlar gösterilir.',
    empty: 'Bu iş ortağının rolleri için tanımlanmış özel alan yok.',
    saved: 'Özel alanlar kaydedildi.',
  },
};
